<template>
    <div
        :class="{ 'cz2__non-interactive': isDisabled }"
        class="selection-card__oos"
    >
        <p class="selection-card__oos-copy">
            {{ $t('OOS_WARNING_TITLE') }}
        </p>

        <img
            src="../../assets/icons/alert.svg"
            alt=""
            aria-hidden="true"
            class="selection-card__oos-icon"
        >
    </div>
</template>

<style lang="scss">
    @import '../../style/variables';

    #cz2.cz2 {
        .selection-card {
            .selection-card__oos,
            .selection-card__oos-icon {
                position: absolute;
            }

            .selection-card__oos {
                width: 100%;
                height: 100%;

                display: flex;
                align-items: center;
            }

            .selection-card__oos-copy {
                margin: 0;
                transform: rotate(-30deg);
                width: 100%;

                color: white;
                font-family: var(--cz-font-900-family);
                font-weight: var(--cz-font-900-weight);
                font-size: 20px;
                text-transform: uppercase;
                text-shadow: 2px 2px #000;
                text-align: center;
            }

            .selection-card__oos-icon {
                bottom: 0;
                right: 0;

                width: 50px;
                height: 46px;
            }

            @include respond-above(sm) {
                .selection-card__oos-copy {
                    font-size: 23px;
                }
            }

            @include respond-above(xl) {
                .selection-card__oos-icon {
                    width: 60px;
                    height: 56px;
                }
            }

            @include respond-above(2xl) {
                .selection-card__oos-copy {
                    font-size: 33px;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
